import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { FormlySelectModule } from "@ngx-formly/core/select";
import { omit } from "lodash";
import { Message } from "primeng/message";
import { NewUiSelectbuttonComponent } from "../../shared/form/selectbutton/new-ui-selectbutton.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-selectbutton",
  templateUrl: "./new-ui-formly-selectbutton.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    FormlyModule,
    FormlySelectModule,
    AsyncPipe,
    Message,
    NewUiSelectbuttonComponent,
  ],
})
export class NewUiFormlySelectbuttonComponent extends FieldType {
  override defaultOptions = {
    props: {
      hideLabel: true,
      options: [],
    },
  };

  // otherwise the `id` attribute is also applied to the `p-selectbutton`
  // which is wrong as the `id` attribute is unique per HTML page
  readonly fieldWithoutId = omit(this.field, "id");
}
